export const WEIGHT_UNITS = [
  "gram",
  "grams",
  "g",
  "petagram",
  "petagrams",
  "Pg",
  "teragram",
  "teragrams",
  "Tg",
  "gigagram",
  "gigagrams",
  "Gg",
  "megagram",
  "megagrams",
  "Mg",
  "kilogram",
  "kilograms",
  "kg",
  "hectogram",
  "hectograms",
  "hg",
  "decagram",
  "decagrams",
  "dag",
  "decigram",
  "decigrams",
  "dg",
  "centigram",
  "centigrams",
  "cg",
  "milligram",
  "milligrams",
  "mg",
  "microgram",
  "micrograms",
  "μg",
  "µg",
  "nanogram",
  "nanograms",
  "ng",
  "picogram",
  "picograms",
  "pg",
  "femtogram",
  "femtograms",
  "fg",
  "tonne",
  "tonnes",
  "metric ton",
  "metric tons",
  "t",
  "kilotonne",
  "kilotonnes",
  "kt",
  "megatonne",
  "megatonnes",
  "Mt",
  "gigatonne",
  "gigatonnes",
  "Gt",
  "pound",
  "pounds",
  "lb",
  "stone",
  "stones",
  "st",
  "ounce",
  "ounces",
  "oz",
  "short ton",
  "short tons",
  "US ton",
  "US tons",
  "long ton",
  "long tons",
  "imperial ton",
  "imperial tons",
  "displacement ton",
  "displacement tons",
].map((u) => u.toLowerCase());

export const HEIGHT_UNITS = [
  "meter",
  "meters",
  "metre",
  "metres",
  "m",
  "petameter",
  "petametre",
  "petameters",
  "petametres",
  "Pm",
  "terameter",
  "terametre",
  "terameters",
  "terametres",
  "Tm",
  "gigameter",
  "gigametre",
  "gigameters",
  "gigametres",
  "Gm",
  "megameter",
  "megametre",
  "megameters",
  "megametres",
  "Mm",
  "kilometer",
  "kilometre",
  "kilometers",
  "kilometres",
  "km",
  "hectometer",
  "hectometre",
  "hectometers",
  "hectometres",
  "hm",
  "decameter",
  "decametre",
  "decameters",
  "decametres",
  "dam",
  "decimeter",
  "decimetre",
  "decimeters",
  "decimetres",
  "dm",
  "centimeter",
  "centimetre",
  "centimeters",
  "centimetres",
  "cm",
  "millimeter",
  "millimetre",
  "millimeters",
  "millimetres",
  "mm",
  "micrometer",
  "micrometre",
  "micrometers",
  "micrometres",
  "μm",
  "µm",
  "nanometer",
  "nanometre",
  "nanometers",
  "nanometres",
  "nm",
  "picometer",
  "picometre",
  "picometers",
  "picometres",
  "pm",
  "femtometer",
  "femtometre",
  "femtometers",
  "femtometres",
  "fm",
  "foot",
  "feet",
  "ft",
  "'",
  "inch",
  "inches",
  "in",
  '"',
  "yard",
  "yards",
  "yd",
  "mile",
  "miles",
  "mi",
  "nautical mile",
  "nautical miles",
  "M",
  "NM",
  "nmi",
  "light-year",
  "light-years",
  "ly",
  "pica",
  "picas",
  "pc",
  "point",
  "points",
].map((u) => u.toLowerCase());

export const TEMPERATURE_UNITS = [
  "kelvin",
  "kelvins",
  "K",
  "petakelvin",
  "petakelvins",
  "PK",
  "terakelvin",
  "terakelvins",
  "TK",
  "gigakelvin",
  "gigakelvins",
  "GK",
  "megakelvin",
  "megakelvins",
  "MK",
  "kilokelvin",
  "kilokelvins",
  "kK",
  "hectokelvin",
  "hectokelvins",
  "hK",
  "decakelvin",
  "decakelvins",
  "daK",
  "decikelvin",
  "decikelvins",
  "dK",
  "centikelvin",
  "centikelvins",
  "cK",
  "millikelvin",
  "millikelvins",
  "mK",
  "microkelvin",
  "microkelvins",
  "μK",
  "µK",
  "nanokelvin",
  "nanokelvins",
  "nK",
  "picokelvin",
  "picokelvins",
  "pK",
  "femtokelvin",
  "femtokelvins",
  "fK",
  "fahrenheit",
  "F",
  "celcius",
  "C",
  "rankine",
  "R",
].map((u) => u.toLowerCase());
